import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
import styled from 'styled-components';
import { getPointingTransform } from '../../icon/utils';
var Thumb = styled(Icon).withConfig({
  displayName: "ThumbIcon__Thumb",
  componentId: "sc-1c9rf4u-0"
})(["", ""], function (_ref) {
  var pointing = _ref.pointing;
  return getPointingTransform(pointing);
});
var ThumbIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var ariaLabel = props['aria-label'],
      pointing = props.pointing,
      rest = _objectWithoutProperties(props, ["aria-label", "pointing"]);

  var label = "".concat(ariaLabel, " ").concat(pointing);
  return /*#__PURE__*/React.createElement(Thumb, _extends({
    ref: ref,
    "aria-label": label,
    pointing: pointing
  }, rest), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M28.9 29.69H41.83C42.6256 29.69 43.3886 29.374 43.9512 28.8114C44.5138 28.2487 44.83 27.4857 44.83 26.69V23.57C44.8329 22.7938 44.5876 22.0369 44.1299 21.41L35.21 9.11C34.669 8.36454 33.9594 7.7576 33.139 7.33876C32.3187 6.91991 31.411 6.70107 30.4899 6.70003H25.78C24.7239 6.69465 23.6865 6.97822 22.78 7.52003L18.78 9.88002C18.6043 9.98388 18.4041 10.0391 18.2 10.04H4.56995C4.2676 10.04 3.97765 10.1601 3.76385 10.3739C3.55006 10.5877 3.42993 10.8777 3.42993 11.18V28.45C3.42992 28.7533 3.54974 29.0443 3.76324 29.2597C3.97675 29.475 4.26668 29.5974 4.56995 29.6H14.4799C14.6508 29.6017 14.8192 29.6411 14.973 29.7155C15.1269 29.7898 15.2624 29.8972 15.3699 30.03L18.65 34.09C18.6992 34.1471 18.7396 34.2111 18.77 34.28C19.13 34.96 21.21 39 22.4 41.28C22.6532 41.7643 23.0338 42.1702 23.5008 42.4539C23.9678 42.7377 24.5035 42.8885 25.0499 42.89H26.3099C27.0547 42.894 27.7743 42.6208 28.3288 42.1236C28.8833 41.6264 29.233 40.9408 29.3099 40.2L29.9199 34.05C29.9442 33.9245 29.9442 33.7955 29.9199 33.67L28.9199 29.67L28.9 29.69ZM41.9999 23.63V25.76C42 26.0633 41.8801 26.3543 41.6666 26.5697C41.4531 26.785 41.1632 26.9073 40.8599 26.91H26.6899C26.5155 26.9108 26.3436 26.9513 26.1871 27.0284C26.0307 27.1055 25.8938 27.2171 25.7869 27.3549C25.6799 27.4926 25.6057 27.6529 25.5699 27.8236C25.534 27.9942 25.5375 28.1709 25.58 28.34L26.9699 33.74C26.9996 33.8717 26.9996 34.0083 26.9699 34.14L26.3699 40.14H24.9999L21.1599 32.84C21.1269 32.7779 21.0902 32.7177 21.0499 32.66L16.3599 26.78C16.2015 26.5776 16.1168 26.3271 16.1199 26.07V13H18.58C19.0657 12.9993 19.5423 12.8681 19.96 12.62L24.33 10.03C24.7476 9.78199 25.2242 9.65074 25.71 9.65004H30.6099C31.0376 9.64995 31.4592 9.7514 31.8399 9.94612C32.2207 10.1408 32.5497 10.4233 32.7999 10.77L41.7599 23C41.9 23.1819 41.9835 23.401 41.9999 23.63Z"
  }));
});
ThumbIcon.displayName = 'ThumbIcon';
ThumbIcon.defaultProps = {
  'aria-label': 'Thumbs',
  pointing: 'down'
};
export default ThumbIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/ThumbIcon/index.js
// module id = 1960
// module chunks = 12